import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { observer } from 'mobx-react';
import { Popover, Avatar, Space, Button, Spin } from 'antd';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import { Icon, CreateTeamModal } from '@/components';
import { AccountStore } from '@/stores';
import { useTabNavigate } from '@/hooks/useTabNavigate';
import type { UserInfo, Company } from '@/stores/account';
import type { CreateTeamRefType } from '@/components/CreateTeamModal';
import { toJS } from 'mobx';
import theme from '@/theme';
import './index.less';


interface HeaderLeftContentProps {
  children: React.ReactNode;
  userInfo?: UserInfo;
}

const loginUrl = '/account/login';

const tagMap = new Map([
  [
    1,
    {
      className: 'login-main-tag',
      text: '已授权',
    },
  ],
  [
    2,
    {
      className: 'login-gray-tag',
      text: '未授权',
    },
  ],
  [
    3,
    {
      className: 'login-red-tag',
      text: '已过期',
    },
  ],
]);

const HeaderLeftContent: React.FC<HeaderLeftContentProps> = ({ children, userInfo }) => {
  const navigate = useTabNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [companyList, setCompanyList] = useState<Company[]>([]);
  // const [rightsList, SetRightsList] = useState<any>({});
  const { certificationInfo: certificationInfoParse } = AccountStore;
  const CreateTeamRef = useRef<CreateTeamRefType | null>(null);

  const certificationInfo = useMemo(() => {
    // 认证成功的
    const certificationInfoBefore = certificationInfoParse?.filter(
      (item: any) => item.auditStatus === 1,
    )[0];

    // 认证审核或者失败的
    const certificationInfoNew = certificationInfoParse?.filter(
      (item: any) => item.auditStatus !== 1,
    )[0];

    return certificationInfoNew || certificationInfoBefore;
  }, [toJS(certificationInfoParse)]);
  const isOk =certificationInfo?.auditStatus === 1;
  function renderStatus() {
    
    if (isOk) {
      return (
        <div className="avatar-popover-certification-tag green" style={{cursor: 'default'}}>
          <Icon type="icon-renzheng1" />
          已认证
        </div>
      );
    }
    if (certificationInfo?.auditStatus === 0) {
      return (
        <div className="avatar-popover-certification-tag yellow" style={{cursor: 'default'}}>
          <Icon type="icon-renzheng1" style={{ paddingRight: 2 }} />
          认证审核中
        </div>
      );
    }
    if (certificationInfo?.auditStatus === 2) {
      return (
        <div className="avatar-popover-certification-tag grey" style={{cursor: 'default'}}>
          <Icon type="icon-renzheng1" style={{ paddingRight: 2 }} />
          认证审核未通过
        </div>
      );
    }

    return (
      <div className="avatar-popover-certification-tag grey" style={{cursor: 'default'}}>
        <Icon type="icon-renzheng1" style={{ paddingRight: 2 }} />
        未认证
      </div>
    );
  }

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      AccountStore.getCertificationStatus()
      const data = await AccountStore.getCompanyList();
      setLoading(false);
      const filterCompany = data
        .filter((item) => item.id !== userInfo?.id)
        .sort((a, b) => {
          // 假设 joinStatus 为 1 表示有效公司
          if (a.isValid && !b.isValid) return -1;
          if (!a.isValid && b.isValid) return 1;

          return 0;
        });
      const currentCompany: Company[] = userInfo
        ? [
            {
              id: userInfo?.id,
              companyName: userInfo?.companyName,
              certifyStatus: userInfo?.certificationStatus,
              companyId: userInfo?.companyId,
              name: userInfo?.name,
              joinStatus: 1,
              authorizeStatus: 1, // 默认是未授权状态
            },
          ]
        : [];
      const sortedCompanies = [...currentCompany, ...filterCompany];
      setCompanyList(sortedCompanies);
    };

    open && fetch();
    // open && getEquity();
  }, [open]);
  // const getEquity = async () => {
  //   const res = await AccountStore.getCompanyEquity({
  //     companyId: userInfo?.companyId,
  //     comboTp: 50,
  //   });
  //   SetRightsList(res);
  // };

  // const goPayEquity = () => {
  //   navigate('/module/workbench/account/allRight');
  // };
  const changeCompany = useCallback(
    (id: string) =>
      AccountStore.changeCompany({ id }).then((token) => {
        Cookies.set('token', token);
        Cookies.remove('fenxiaoToken');
        Cookies.remove('miaohuoToken');
        window.location.href = window.location.origin;
      }),
    [],
  );
  const content = useCallback(() => {
    return (
      <div className="avatar-popover-content">
        <Space className="avatar-popover-company">
          <Avatar
            size={50}
            icon={<Icon type="icon-qiye-moren" style={{ fontSize: 30 }} />}
            style={{ background: '#F4F4F4', color: theme.token?.colorPrimary }}
          />
          <div className="flex flex-vertical">
            <div className="avatar-popover-title">{userInfo?.companyName}</div>
            <div className="flex">
              {/* {userInfo?.certificationStatus === 0 ? (
                <span
                  // onClick={() => {
                  //   navigate(
                  //     `/module/workbench/account/accountInfo/certification?id=${userInfo?.companyId}`,
                  //   );
                  // }}
                  className="avatar-popover-certification-tag grey"
                  style={{ cursor: 'default' }}
                >
                  <Icon type="icon-renzheng1" /> 未认证
                </span>
              ) : (
                <span
                  className="avatar-popover-certification-tag blue"
                  style={{ cursor: 'default' }}
                >
                  <Icon type="icon-renzheng1" />
                  已认证
                </span>
              )} */}
              {renderStatus()}
            </div>
          </div>
        </Space>
        <Space className="avatar-popover-user">
          <Avatar
            size={40}
            style={{ background: '#fff', color: theme.token?.colorPrimary }}
            icon={<Icon type="icon-touxiang" style={{ fontSize: 24 }} />}
          />
          <div className="flex flex-vertical">
            <Space>
              <span>{userInfo?.name}</span>
              <span>{userInfo?.mobile?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}</span>
            </Space>
            <div style={{ color: '#aaa' }}>{`ID.${userInfo?.id}`}</div>
          </div>
        </Space>

        {companyList.length > 1 && (
          <div className="avatar-popover-company-card">
            <Spin spinning={loading}>
              <div className={classNames('avatar-popover-company-list', 'fle-scroll')}>
                {companyList.map((item) => {
                  return (
                    <div
                      key={item.id}
                      className={classNames('avatar-popover-company-item', {
                        active: item.id === userInfo?.id,
                        disabled: item.isValid === false,
                      })}
                      onClick={() =>
                        item.id !== userInfo?.id && item.isValid !== false && changeCompany(item.id)
                      }
                    >
                      <Avatar
                        size={40}
                        icon={<Icon type="icon-qiye-moren" style={{ fontSize: 24 }} />}
                        style={{ background: '#F8F8F8', color: theme.token?.colorPrimary }}
                      />
                      <span className="avatar-popover-company-name">{item.companyName}</span>
                      {
                        // 当前选中的企业不显示标签
                        item.id !== userInfo?.id && (
                          <>
                            {item.isValid === false ? (
                              <span className="login-gray-tag login-tag">
                                <Icon type="icon-qiyebukeyong" />
                                不可用企业
                              </span>
                            ) : (
                              <span
                                className={`${
                                  tagMap.get(item.authorizeStatus)?.className
                                } login-tag`}
                              >
                                {tagMap.get(item.authorizeStatus)?.text}
                              </span>
                            )}
                          </>
                        )
                      }
                    </div>
                  );
                })}
              </div>
            </Spin>
          </div>
        )}

        {/* <Button
          ghost
          block
          type="primary"
          className="avatar-popover-blcok-btn"
          onClick={() => {
            setOpen(false);
            CreateTeamRef.current?.setModalVisible(true);
          }}
        >
          创建新团队
        </Button> */}
        <Button
          ghost
          block
          type="primary"
          className="avatar-popover-blcok-btn"
          onClick={() => {
            Promise.allSettled([AccountStore.logout?.(), AccountStore.logoutother?.()]).then(
              (res) => {
                if (res.filter((item) => item.status === 'fulfilled').length > 0) {
                  [
                    'token',
                    'liguanjia_member_token',
                    'liguanjia_supplier_token',
                    'liguanjia_card_token',
                    'liguanjia_product_token',
                  ].forEach(async (item: string) => {
                    await Cookies.remove(item);
                  });
                  window.location.href = loginUrl;
                }
              },
            );
          }}
        >
          退出登录
        </Button>
      </div>
    );
  }, [userInfo, companyList, loading]);

  return (
    <>
      <Popover
        open={open}
        trigger="hover"
        content={content}
        arrow={false}
        rootClassName="avatar-popover"
        overlayInnerStyle={{ padding: 0, marginRight: 10 }}
        onOpenChange={setOpen}
      >
        {children}
      </Popover>
      <CreateTeamModal ref={CreateTeamRef} />
    </>
  );
};
export default React.memo(observer(HeaderLeftContent));
